import React, { useEffect, useMemo, useState } from "react";
import { useParams } from 'react-router';
import { useNavigate, useLocation  } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import ROUTES from "../../../../utilities/Routes";

import Stage from "../../../../components/Stage";
import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import ReactLoading from "react-loading";

import { getOnlyAudiCenters, scrollToInput } from "../../../../utilities/utils";

import {
    setNombreAction,
    setApellidoPaternoAction,
    setTelefonoAction,
    setMovilAction,
    setCorreoAction,
    setEstadoAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setVehiculoAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    setTerminosCondicionesAction,
    setTransferenciaDeDatosAction,
    setContactoMarketingAction,
    setTipoCitaAction,
    setNumeroDeParteAction,
    reiniciarStateAction,
    setTratamientoAction
} from "../../../../actions/accesoriosActions.js";

import {
    getEstados,
    getConcesionarios,
    jsonDeserialize,
} from "../../../../API/CitasServicioRequest/index";

import {
    isOnlyNumbers,
} from "../../../../utilities/Validations";
import { getDetalleArticuloCollection, sendMailAccesoriosCollectionCliente, sendMailAccesoriosCollectionConcesionaria } from "../../../../API/AccesoriosCollectionRequest";
import { validarApellidoPaterno, validarCelular, validarCorreo, validarNombre, validarTelefono } from "../../../../utilities/Validations/lead";
import { sendLeadToSaas } from "../../../../API/SaasRequest";

import { getDetalleArticuloAccesorios } from "../../../../API/AccesoriosCollectionRequest";
import RadioButton from "../../../../components/Inputs/Radio/index.js";

const FormAudiNuevo = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.accesorios);

    const { idArticle } = useParams();
    const { pathname } = useLocation();
    const lastSegment = pathname.split("/").filter(Boolean).pop()?.toLowerCase();
    const isFormularioGeneral = !idArticle;
    const titleStage = isFormularioGeneral
    ? lastSegment === "accesorios"
        ? "Audi Accesorios"
        : "Audi Collection"
    : "Información de artículo"
    const positionStage = !idArticle ? "top" : "bottom";
    let navigate = useNavigate();

    const setTratamiento = (inTratamiento) => {
        dispatch(setTratamientoAction(inTratamiento));
    };
    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setApellidoPaterno = (inApellidoPaterno) => {
        dispatch(setApellidoPaternoAction(inApellidoPaterno));
    };
    const setTelefono = (inTelefono) => {
        dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setEstado = (inEstado) => {
        dispatch(setEstadoAction(inEstado));
    };
    const setIdConcesionario = (inIdConcesionario) => {
        dispatch(setIdConcesionarioAction(inIdConcesionario));
    };
    const setConcesionario = (inConcesionario) => {
        dispatch(setConcesionarioAction(inConcesionario));
    };
    const setVehiculo = (inVehiculo) => {
        dispatch(setVehiculoAction(inVehiculo));
    };
    const setTipoCita = (inTipoCita) => {
        dispatch(setTipoCitaAction(inTipoCita));
    };
    const setNumeroDeParte = (inNumeroDeParte) => {
        dispatch(setNumeroDeParteAction(inNumeroDeParte));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setTerminosCondiciones = (inTerminosCondiciones) => {
        dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    };
    const setTransferenciaDeDatos = (inAvisosDePrivacidad) => {
        dispatch(setTransferenciaDeDatosAction(inAvisosDePrivacidad));
    };
    const setContactoMarketing = (inTerminosCondiciones) => {
        dispatch(setContactoMarketingAction(inTerminosCondiciones));
    };

    const [pathName, setPathName] = useState("");
    const [detalleArticulo, setDetalleArticulo] = useState(null);
    const [modeloName, setModeloName] = useState("");
    const [imgBanner, setImgBanner] = useState("");
    const [loadingArticulo, setLoadingArticulo] = useState(true);

    const [estados, setEstados] = useState([]);
    const [concesionarios, setConcesionarios] = useState([]);

    const [showErrorArticulo, setErrorArticulo] = useState(false);

    const [showErrorEstado, setErrorEstado] = useState(false);
    const [showErrorConcesionario, setErrorConcesionario] = useState(false);
    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);

    const filterConcesionarios = useMemo(() => {
        if (concesionarios.length > 0 && estados.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return concesionarios.filter(
                (concesionario) => concesionario.stateName === estadoSelected.nombreedo
            );
        }
        return [];
    }, [objSubmit.provincia, estados, concesionarios]);

    useEffect(() => {
        const path = window.location.pathname;
        const pathName = path.split("/")[2];
        const capitalizedPathName = pathName.charAt(0).toUpperCase() + pathName.slice(1);

        document.title = capitalizedPathName + " - Información de artículo";

        if (capitalizedPathName === "Accesorios") {
            setImgBanner(
                process.env.REACT_APP_RESOURCES_IMAGES_PATH +
                (idArticle
                    ? "formsSalesforce/form_accesorios-collection_header.jpg"
                    : "formsSalesforce/asset_form_audi_accesorios.jpg")
            );
        }
        if (capitalizedPathName === "Collection") {
            setImgBanner(
                process.env.REACT_APP_RESOURCES_IMAGES_PATH +
                (idArticle
                    ? "formsSalesforce/banner_form_audi_collection.jpg"
                    : "formsSalesforce/banner_form_audi_collection_flipbook.jpg")
            );
        }
        const funGetEstado = async () => {
            getEstados().then((responseEstados) => {
                setEstados(responseEstados.data);
            });
        };

        const funGetConcesionarios = async () => {
            getConcesionarios().then((responseConcesionarios) => {
                const filterConcesionariosSinMasaryk = responseConcesionarios.data.data.filter(concesionario => concesionario.dealerNumber !== 3359);
                const filterConcesionarios = getOnlyAudiCenters(filterConcesionariosSinMasaryk);
                const filterConcesionariosSCFiladelfia = responseConcesionarios.data.data.filter(concesionario => concesionario.dealerNumber === 3357);

                //console.log("filterConcesionarios", filterConcesionarios);//Service Center Filadelfia
                //console.log("filterConcesionariosSCFiladelfia", filterConcesionariosSCFiladelfia);
                //console.log(filterConcesionarios.concat(filterConcesionariosSCFiladelfia));
                setConcesionarios(filterConcesionarios.concat(filterConcesionariosSCFiladelfia));
            });
        };

        const funGetDetalleArticulo = async () => {
            if (capitalizedPathName === "Accesorios") {
                if (!idArticle) {
                    setLoadingArticulo(false);
                    return;
                }
                getDetalleArticuloAccesorios(idArticle)
                    .then((responseDetalleArticulo) => {
                        let detArticulo = jsonDeserialize(responseDetalleArticulo.data.data);
                        setDetalleArticulo(detArticulo);

                        setModeloName(detArticulo.catDetails.categoria);
                        setVehiculo(detArticulo.catDetails.categoria);
                        setTipoCita(capitalizedPathName);
                        setNumeroDeParte(detArticulo.NumParte);
                        setLoadingArticulo(false);
                    })
                    .catch((errorMessageGetMantenimiento) => {
                        setLoadingArticulo(false);
                        setErrorArticulo(true);
                        console.log("ERORR - En la petición");
                    });
            }

            if (capitalizedPathName === "Collection") {
                if (!idArticle) {
                    setLoadingArticulo(false);
                    return;
                }
                getDetalleArticuloCollection(idArticle)
                    .then((responseDetalleArticulo) => {
                        let detArticulo = jsonDeserialize(responseDetalleArticulo.data.data);
                        setDetalleArticulo(detArticulo);

                        setModeloName(detArticulo.catDetails.categoria);
                        setVehiculo(detArticulo.catDetails.categoria);
                        setVehiculo(detArticulo.catDetails.categoria);
                        setTipoCita(capitalizedPathName);
                        setNumeroDeParte(detArticulo.NumParte);
                        setLoadingArticulo(false);
                    })
                    .catch((errorMessageGetMantenimiento) => {
                        setLoadingArticulo(false);
                        setErrorArticulo(true);
                        console.log("ERORR - En la petición");
                    });
            }

        };

        funGetEstado();
        funGetConcesionarios();
        funGetDetalleArticulo();
        setPathName(capitalizedPathName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idArticle])

    useEffect(() => {

        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_ACCESORIOS_COLLECTION_GA_ID);
        }

    }, []);

    const getNombreArticulo = ({ idArticle, lastSegment, lead, detalleArticulo }) => {
        if (!idArticle) {
            return lastSegment === "accesorios"
            ? "Audi Accesorios 2025 - FlipBook"
            : "Audi Collection 2025 - FlipBook";
        }
        return `${lead.numeroDeParte} - ${detalleArticulo?.Nombre || ""}`;
    };

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {
            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit }

            lead.numeroConcesionaria = objSubmit.numeroConcesionaria < 1000
            ? "0" + objSubmit.numeroConcesionaria
            : "" + objSubmit.numeroConcesionaria;
            
            delete lead.avisoPrivacidad;
            delete lead.terminosCondiciones;
            delete lead.nombreDelVehiculo;
            
            const contactos = getContactosConcesionaria(objSubmit.numeroConcesionaria);

            lead.descripcion = (lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim());

            const nombreArticulo = getNombreArticulo({
                idArticle,
                lastSegment,
                lead,
                detalleArticulo,
            });
            sendMailAccesoriosCollectionCliente(lead)
                .then((response) => {
                    sendMailAccesoriosCollectionConcesionaria({ ...lead, contactos })
                    setLoadingSubmit(false);
                    dispatch(reiniciarStateAction());
                    handleSendLeadToSaas(lead, null, true, nombreArticulo, "Lead enviado correctamente");
                    const formName = !idArticle ? `flipbook-${lastSegment}` : "";
                    if (pathName === "Accesorios") {
                        const url = ROUTES.ACCESORIOSGENERAL + ROUTES.ACCESORIOSTHANKYOU + (formName ? `/${formName}` : "");
                        navigate(url);
                    }
                    else if (pathName === "Collection") {
                        const url = ROUTES.COLLECTIONGENERAL + ROUTES.COLLECTIONTHANKYOU + (formName ? `/${formName}` : "");
                        navigate(url);
                    }
                })
                .catch((error) => {
                    handleSendLeadToSaas(lead, null, false, nombreArticulo, error?.response?.data?.message || error?.message || "Error en envío de lead");
                    setLoadingSubmit(false);
                    setShowErrorSubmit(true);
                    console.log("ERROR: ", error);
                });

        }

    }

    const handleSendLeadToSaas = (lead, idTransaccion, status, numeroDeParte, message) => {      
        sendLeadToSaas(lead, process.env.REACT_APP_ACCESORIOS_COLLECTION_FORM_ID, idTransaccion, status, numeroDeParte, message)
            .then(respuesta => {
                // manejar respuesta
            })
            .catch(error => {
                // manejar error
                console.error("Error en log: " + error)
            });
    }

    const getContactosConcesionaria = (numeroConcesionaria) => {
        const dealerInfo = concesionarios.find(
            (dealer) => dealer.dealerNumber === numeroConcesionaria
        );

        if (dealerInfo.contactos === null) return [process.env.REACT_APP_ACCESORIOS_COLLECTION_CORREO_DEFAULT];

        let contactos =
            dealerInfo.contactos.split(",").length > 9
                ? dealerInfo.contactos
                    .split(",")[10]
                    .split(";")
                    .map((item) => item.trim())
                : [];

        if (contactos.includes("N/A")) return [process.env.REACT_APP_ACCESORIOS_COLLECTION_CORREO_DEFAULT];

        return contactos
    }

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false
        }
        if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
            scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
            return false;
        }
        // if (validarTelefono(objSubmit.telefono) === false) {
        //     scrollToInput("telefono", "Por favor ingresa un valor válido");
        //     return false;
        // }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (objSubmit.provincia === "") {
            scrollToInput("estado");
            setErrorEstado(true);
            return false;
        } else {
            setErrorEstado(false);
        }
        if (objSubmit.numeroConcesionaria === "" || objSubmit.concesionariaPreferida === "") {
            scrollToInput("concesionario");
            setErrorConcesionario(true);
            return false;
        } else {
            setErrorConcesionario(false);
        }

        if (objSubmit.descripcion.length > 1000) {
            scrollToInput("comentarios");
            return false;
        }

        if (
            objSubmit.avisoPrivacidad === false ||
            objSubmit.terminosCondiciones === false ||
            objSubmit.permisoTransferenciaDatos === false ||
            objSubmit.permisoContactoMarketing === false
        ) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true
    }

    return (
        <>
            <main className="audi-nuevo">
                <Stage title={ titleStage } img={imgBanner} positionTitle={positionStage} />
                <div className="button-back-container">
                    {isFormularioGeneral ? (
                        <ButtonBack
                        url={
                            lastSegment === "accesorios"
                            ? "https://www.appsaudi.com.mx/catalogo_audi_accesorios/new.html"
                            : "https://www.appsaudi.com.mx/catalogo_audi_collection/new.html"
                        }
                        top
                        />
                    ) : (
                        <ButtonBack />
                    )}
                </div>
                {
                    loadingArticulo ? (
                        <div className="vh-100  d-flex flex-column  align-items-center">
                            <ReactLoading type="spin" color="#000" height={50} width={50} />
                            <h2 className="text-center mb-5">Cargando información del articulo</h2>
                        </div>
                    ) : showErrorArticulo ? (
                        <div className="vh-100 d-flex flex-column">
                            <div className="text-center mt-5 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="50" height="50">
                                    <g id="_01_align_center" data-name="01 align center">
                                        <polygon points="15.293 7.293 12 10.586 8.707 7.293 7.293 8.707 10.586 12 7.293 15.293 8.707 16.707 12 13.414 15.293 16.707 16.707 15.293 13.414 12 16.707 8.707 15.293 7.293" />
                                        <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z" />
                                    </g>
                                </svg>
                            </div>
                            <h2 className="text-center mb-5">Artículo no encontrado</h2>
                        </div>
                    )
                        : (
                            <section className="container w-100 p-4 p-md-3 pt-3">
                                {!isFormularioGeneral && detalleArticulo && (
                                    <div className="mb-5 pb-0 pb-lg-5 mt-4">
                                        <span className="d-block mb-3 h6 font-weight-bold">El artículo que te interesa:</span>
                                        <div className="d-flex flex-column flex-lg-row gap-4">
                                            <div className="accesorios__info_container">
                                                <h2 className="m-0">{detalleArticulo.Nombre}</h2>
                                                <span className="text-muted">No. de Artículo: {detalleArticulo.NumParte}</span>
                                            </div>

                                            <div className="d-flex flex-column align-items-lg-center justify-content-center">
                                                <span className="d-block text-muted h5 m-0">{modeloName}</span>
                                                <span className="text-muted">Modelo</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <p className="mb-3">
                                    Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas.
                                </p>
                                <form className="w-100 pt-5" onSubmit={onSubmit}>
                                    <section className="w-100 mb-5">
                                        <h3>Trato</h3>
                                        <div className="d-flex flex-column flex-md-row gap-4" onChange={(e) => {
                                            setTratamiento(e.target.value)
                                        }}>
                                            <RadioButton label="Sr." name="tratamiento" value="Sr" defaultChecked={objSubmit.tratamiento === "Sr"} />
                                            <RadioButton label="Sra." name="tratamiento" value="Sra" defaultChecked={objSubmit.tratamiento === "Sra"} />
                                            <RadioButton label="Srita." name="tratamiento" value="Srita" defaultChecked={objSubmit.tratamiento === "Srita"} />
                                        </div>
                                    </section>
                                    <h3>Datos de contacto</h3>
                                    <div className="fields-grid mt-4 mb-5">
                                        <div className="order-1">
                                            <InputText
                                                label="¿Cuál es tu nombre?"
                                                secondaryLabel="Nombre"
                                                name="nombre"
                                                maxLength={40}
                                                onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    e.target.value = value;
                                                    setNombre(value);
                                                }}
                                                validator={validarNombre}
                                                errorMessage={objSubmit.nombre.length > 40 ? "Máx. 40 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                                            />
                                        </div>
                                        <div className="order-2">
                                            <InputText
                                                label="¿Cuál es tu apellido?"
                                                secondaryLabel="Apellido"
                                                name="apellidoPaterno"
                                                maxLength={80}
                                                onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    e.target.value = value;
                                                    setApellidoPaterno(value);
                                                }}
                                                errorMessage={objSubmit.apellidoPaterno.length > 80 ? "Máx. 80 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                                                validator={validarApellidoPaterno}
                                            />
                                        </div>
                                        <div className="order-5">
                                            <InputText
                                                label="¿Cuál es tu número móvil?"
                                                secondaryLabel="Móvil"
                                                name="movil"
                                                value={objSubmit.celular}
                                                maxLength={10}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 10) {
                                                        setMovil(e.target.value);
                                                    }
                                                }}
                                                errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                                validator={validarCelular}
                                            />
                                        </div>
                                        <div className="order-3">
                                            <InputText
                                                label="¿Cuál es tu número de teléfono?"
                                                secondaryLabel="Teléfono"
                                                name="telefono"
                                                value={objSubmit.telefono}
                                                maxLength={10}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 10) {
                                                        setTelefono(e.target.value);
                                                    }
                                                }}
                                                errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                                validator={validarTelefono}
                                            />
                                        </div>
                                        <div className="order-4">
                                            <InputText
                                                label="¿Cuál es tu e-mail?"
                                                secondaryLabel="E-mail"
                                                name="correo"
                                                maxLength={80}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 80)
                                                        setCorreo(e.target.value);
                                                }}
                                                errorMessage="Por favor usa un e-mail válido con formato: nombre@dominio.com"
                                                validator={validarCorreo}
                                            />
                                        </div>
                                        <div className="order-6">
                                            <InputSelect
                                                label="Estado"
                                                name="estado"
                                                options={estados.map((item, i) => ({
                                                    value: item.nombreedo,
                                                    label: item.nombreedo,
                                                }))}
                                                onChange={(e) => {
                                                    setEstado(e.target.value);
                                                    setIdConcesionario("");
                                                    setConcesionario("");
                                                }}
                                                errorMessage="Selecciona una opción"
                                                showError={showErrorEstado}
                                                defaultValue={objSubmit.provincia}
                                            />
                                        </div>
                                    </div>
                                    <h3 className="pt-5">Información de Concesionaria</h3>
                                    <div className="w-100 d-flex flex-column flex-md-row gap-5 mt-4 mb-5">
                                        <div className="w-100 w-md-50 d-flex flex-column gap-5">
                                            <InputSelect
                                                label="Concesionario"
                                                name="concesionario"
                                                options={filterConcesionarios.map((item, i) => ({
                                                    value: item.dealerNumber,
                                                    label: item.name,
                                                }))}
                                                onChange={(e) => {
                                                    const concesionario = concesionarios.find(
                                                        (con) => con.dealerNumber === parseInt(e.target.value)
                                                    );

                                                    setIdConcesionario(concesionario.dealerNumber);
                                                    setConcesionario(concesionario.name);
                                                }}
                                                showError={showErrorConcesionario}
                                                noDataMessage={objSubmit.provincia === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                                                showNoDataMessage={objSubmit.provincia !== ""}
                                                errorMessage="Selecciona una opción"
                                                defaultValue={objSubmit.numeroConcesionaria}
                                            />
                                        </div>
                                        <div className="w-100"></div>
                                    </div>
                                    <div>
                                        <InputTextArea
                                            name="comentarios"
                                            placeholder="Escribe aquí las dudas o información que te gustaría conocer."
                                            errorMessage="Tu comentario excede los 1,000 caracteres"
                                            maxLength={1000}
                                            onChange={(e) => {
                                                setComentarios(e.target.value);
                                            }}
                                            isValid={true}
                                        />
                                    </div>
                                    <div className="mt-5 pt-5">
                                        <h3 >Estamos comprometidos con tu privacidad</h3>
                                        <p className="mt-4 pb-5">
                                            En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
                                        </p>

                                        <div className="d-flex flex-column gap-3">
                                            <InputCheckBox
                                                rounded
                                                label="Aceptar todo"
                                                onChange={(e) => {

                                                    var checkboxes =
                                                        document.getElementsByName("checkboxgroup");

                                                    checkboxes.forEach((cbx) => {
                                                        cbx.checked = e.target.checked;
                                                    });
                                                    setAvisosDePrivacidad(e.target.checked);
                                                    setTerminosCondiciones(e.target.checked);
                                                    setTransferenciaDeDatos(e.target.checked);
                                                    setContactoMarketing(e.target.checked);
                                                }}
                                            />

                                            <InputCheckBox
                                                name="checkboxgroup"
                                                onChange={(e) => {
                                                    setAvisosDePrivacidad(e.target.checked);
                                                }}
                                            >
                                                <span>
                                                    He leído y acepto el{" "}
                                                    <a
                                                        href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Aviso de Privacidad.
                                                    </a>
                                                </span>
                                            </InputCheckBox>
                                            <InputCheckBox
                                                name="checkboxgroup"
                                                onChange={(e) => {
                                                    setTerminosCondiciones(e.target.checked);
                                                }}
                                            >
                                                <span>
                                                    He leído y acepto el{" "}
                                                    <a
                                                        href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Términos y Condiciones.
                                                    </a>
                                                </span>
                                            </InputCheckBox>
                                            <InputCheckBox
                                                label="Acepto que los datos aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, para dar seguimiento a mi solicitud."
                                                name="checkboxgroup"
                                                onChange={(e) => {
                                                    setTransferenciaDeDatos(e.target.checked);
                                                }}
                                            />
                                            <InputCheckBox
                                                label="Acepto que los datos aquí proporcionados sean transferidos a Facebook Mexico S. de R.L. de C.V., Twitter, Inc. y Google Operaciones de México, S. de R.L. de C.V., para efectos de marketing."
                                                name="checkboxgroup"
                                                onChange={(e) => {
                                                    setContactoMarketing(e.target.checked);
                                                }}
                                            />

                                            <span
                                                className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                                                    }`}
                                            >
                                                Para continuar, acepta nuestras declaraciones de conformidad.
                                            </span>

                                        </div>

                                    </div>
                                    <div>
                                        {!loadingSubmit ? (
                                            <button className={`button-enviar`} type="submit">
                                                Enviar
                                            </button>
                                        ) : (
                                            <button
                                                className="button-enviar disabled"
                                                type="button"
                                                disabled={true}
                                            >
                                                <div className="loading-g loading-send loading-btn">
                                                    <div>
                                                        <ReactLoading
                                                            type="cylon"
                                                            color="#fff"
                                                            width={"100%"}
                                                            height={"58px"}
                                                        />
                                                    </div>
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                    <span
                                        className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                                            }`}
                                    >
                                        Hubo un error. Por favor, Intentelo más tarde.
                                    </span>
                                </form>
                            </section>
                        )
                }

            </main>
        </>
    );
};

export default FormAudiNuevo;